/** "1 clip", "3 clips"; pass `many` for irregular nouns ("match", "matches"). */
export function plural(count, one, many = one + "s") {
  return count + " " + (count === 1 ? one : many);
}
